import React from 'react';
import classes from './Nav.module.css';

const Nav = (props) => (
  <div className={`${classes.Nav} Tabs`}>
    <nav>
      <ul>{props.children}</ul>
    </nav>
  </div>
);

export default Nav;
